import { IconButton } from '@chakra-ui/react'
import { ErrorBoundary } from '@sentry/react'
import type { FC } from 'react'

import SuggestProductInitiativesButton from './suggestProductInitiativesButton'

import type { ButtonProps } from '@app/components/ui/button'
import type { DomainNode } from '@app/types'
import ICON_MAP from '@app/utils/iconMap'

const bodyButtonStyles: Partial<ButtonProps> = {
  w: '100%',
  px: 2,
  outline: 'none',
  variant: 'ghost',
  textAlign: 'start'
}

type Props = {
  node: Pick<DomainNode, 'nodeId' | 'data'>
}

const AiAssistantButton: FC<Props> = ({ node }) => (
  <ErrorBoundary>
    <SuggestProductInitiativesButton node={node}>
      {({ onClick }) => (
        <IconButton
          borderRadius="none"
          aria-label="ai suggestion"
          size="sm"
          variant="outline"
          onClick={onClick}
          {...bodyButtonStyles}
        >
          <ICON_MAP.AiPrompt />
        </IconButton>
      )}
    </SuggestProductInitiativesButton>
  </ErrorBoundary>
)

export default AiAssistantButton
